import { JobModel } from "./jobSlice";

export async function fetchJobs() {
    let data: JobModel[] = await (await fetch('/api/FetchJobs')).json();
    return data;
}